import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface ApiDataResponse {
  data: any[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  summary?: Record<string, number>;
}

export const getApiDatas = async (
  integrationId: string,
  page: number = 1,
  tipoRegistro?: string
): Promise<ApiDataResponse> => {
  const { data } = await api.get(`/apiDatas/${integrationId}`, {
    params: {
      page,
      limit: 50,
      tipoRegistro: tipoRegistro && tipoRegistro !== 'ALL' ? tipoRegistro : undefined
    }
  });
  return data;
};

export const useApiDatas = (integrationId: string | null, page: number, tipoRegistro?: string) => {
  return useQuery(
    ['apiDatas', integrationId, page, tipoRegistro],
    () => getApiDatas(integrationId!, page, tipoRegistro),
    {
      enabled: !!integrationId,
      keepPreviousData: true
    }
  );
};
